import BaseRepository from "~/api/BaseRepository";
import type { $Fetch } from "nitropack";

export const SkillRepository = (client: $Fetch) => ({
    ...BaseRepository(client)('v2/skills'),
});